import { Link } from "react-router-dom";
import { useCartStore } from "../stores/useCartStore";
import { motion } from "framer-motion";
import { ShoppingCart, RefreshCw } from "lucide-react";
import CartItem from "../components/CartItem";
import PeopleAlsoBought from "../components/PeopleAlsoBought";
import OrderSummary from "../components/OrderSummary";
import GiftCouponCard from "../components/GiftCouponCard";
import ShippingOptions from "../components/ShippingOptions";

const CartPage = () => {
	const { cart, refreshCart, isGuestMode } = useCartStore();

	return (
		<div className='py-8 md:py-16 mt-20 bg-gray-100 min-h-screen'>
			<div className='mx-auto max-w-screen-xl px-4 2xl:px-0 h-full'>
				{/* הודעה למשתמש אורח */}
				{isGuestMode && cart.length > 0 && (
					<div className='mb-6 p-4 bg-brand-primary border border-brand-primary-light rounded-lg'>
						<div className='flex items-center gap-2 text-white'>
							<ShoppingCart className='w-5 h-5' />
							<span className='font-medium text-white'>מוצרים נשמרו זמנית</span>
						</div>
						<p className='text-sm text-white mt-1'>
							הסל שלך נשמר באופן זמני. 
							<Link to="/login" className='text-blue-500 hover:text-blue-300 underline mx-1'>
								התחבר
							</Link>
							כדי לשמור את הסל לצמיתות.
						</p>
					</div>
				)}
				
				{cart.length > 0 && (
					<div className='mb-6 flex justify-between items-center'>
						<h1 className='text-2xl font-bold text-gray-900'>עגלת הקניות שלי</h1>
						<button
							onClick={refreshCart}
							className='flex items-center gap-2 px-4 py-2 bg-brand-primary hover:bg-brand-primary/80 text-white rounded-lg transition-colors'
						>
							<RefreshCw className='w-4 h-4' />
							רענן עגלה
						</button>
					</div>
				)}
				<div className='mt-6 sm:mt-8 md:gap-6 lg:flex lg:items-start xl:gap-8'>
					<motion.div
						className='mx-auto w-full flex-none lg:max-w-2xl xl:max-w-4xl'
						initial={{ opacity: 0, x: -20 }}
						animate={{ opacity: 1, x: 0 }}
						transition={{ duration: 0.5, delay: 0.2 }}
					>
						{cart.length === 0 ? (
							<EmptyCartUI />
						) : (
							<div className='space-y-6'>
								{cart.map((item) => (
									<CartItem key={item._id} item={item} />
								))}
							</div>
						)}
						{cart.length > 0 && <PeopleAlsoBought />}
					</motion.div>

					{cart.length > 0 && (
						<motion.div
							className='mx-auto mt-6 max-w-4xl flex-1 space-y-6 lg:mt-0 lg:w-full'
							initial={{ opacity: 0, x: 20 }}
							animate={{ opacity: 1, x: 0 }}
							transition={{ duration: 0.5, delay: 0.4 }}
						>
							<ShippingOptions />
							<OrderSummary />
							<GiftCouponCard />
						</motion.div>
					)}
				</div>
			</div>
		</div>
	);
};
export default CartPage;

const EmptyCartUI = () => (
	<motion.div
		className='flex flex-col items-center justify-center space-y-4 py-16'
		initial={{ opacity: 0, y: 20 }}
		animate={{ opacity: 1, y: 0 }}
		transition={{ duration: 0.5 }}
	>
		<ShoppingCart className='h-24 w-24 text-gray-300' />
		<h3 className='text-2xl font-semibold '>העגלה שלך ריקה</h3>
		<p className='text-gray-400'>נראה שעדיין לא הוספת מוצרים לעגלה.</p>
		<Link
			className='mt-4 rounded-md bg-brand-primary px-6 py-2 text-white transition-colors bg-brand-primary-hover'
			to='/'
		>
			התחל לקנות
		</Link>
	</motion.div>
);
